import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import RectifierAlarmTd from "../../../CustomMemo/Rectifier/RectifierAlarmTd";

export default function RectifierCard() {
 const selector_rectifier_alarm = useSelector((state) => state.rectifierAlarmReducer)
 const selector_rectifier = useSelector((state) => state.rectifierReducer)
// console.log(selector_rectifier_alarm?.alarm_count);
const alarm_count=selector_rectifier_alarm?.alarm_count;
 return (
    <>
      <div className="row">
        <div className="col-xl-3 col-md-6 d-flex">
          <Link to="/rectifier_monitoring" className="card flex-fill text-decoration-none text-reset">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10 bg-pink-transparent border border-pink d-flex align-items-center justify-content-center">
                      <i class="fa-duotone fa-solid fa-tablet-screen fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Total Rectifier</p>
                    <h4>{selector_rectifier?.rectifier_count?.length>0 && selector_rectifier?.rectifier_count?.reduce((acc, curr) => acc + Number(curr.total_rectifier), 0)}</h4>
                  </div>
                </div>

              </div>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-md-6 d-flex">
          <div className="card flex-fill">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10 bg-success-transparent border border-success d-flex align-items-center justify-content-center">

                      <i class="fa-light fa-plug fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Connected Rectifier</p>
                    <h4>{selector_rectifier?.rectifier_count?.length>0 && selector_rectifier?.rectifier_count?.reduce((acc, curr) => acc + Number(curr.total_rectifier), 0)}</h4>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6 d-flex">
          <div className="card flex-fill">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center">
                      <i class="fa-light fa-signal-stream-slash"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Disconnect Rectifier</p>
                    <h4>0</h4>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6 d-flex">
          <div className="card flex-fill">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10 bg-info-transparent border border-info d-flex align-items-center justify-content-center">
                      <i class="fa-regular fa-code-branch fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Total Brand</p>
                    <h4>{selector_rectifier?.rectifier_count?.length}</h4>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="row">
            <div className="col-xl-12">
              <table className="table table-borderless rms-all-nav m-0">
                <tbody>
                  {!selector_rectifier?.loading && selector_rectifier?.rectifier_count?.length>0 && selector_rectifier?.rectifier_count?.map((brand, bIndex) => (
                  <RectifierAlarmTd className="text-center bg-info fw-bold"  link={`/rectifier_monitoring?brand=${brand?.rectifier_brand_id}`} title={brand?.brand_name} alarm={brand?.total_rectifier} key={bIndex}/>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

        </div>
        <div className="col-md-4">
          <div className="row">
            <div className="col-xl-12">
              <table className="table table-borderless rms-all-nav m-0">
                <tbody>
                  <RectifierAlarmTd link={`/rectifier_live_alarm?type=1`}  className={`text-center fw-bold ${alarm_count?.length>0 && alarm_count[0]?.mains_fail?'badge-custom-danger':'badge-success'}`} title={`Mains Fail`} alarm={alarm_count?.length>0?alarm_count[0]?.mains_fail:0} />
                  <RectifierAlarmTd link={`/rectifier_live_alarm?type=5`} className={`text-center fw-bold ${alarm_count?.length>0 && alarm_count[0]?.dc_low?'badge-custom-danger':'badge-success'}`} title={`DC Low`} alarm={alarm_count?.length>0?alarm_count[0]?.dc_low:0} />
                  <RectifierAlarmTd link={`/rectifier_live_alarm?type=2`} className={`text-center fw-bold ${alarm_count?.length>0 && alarm_count[0]?.module_fault?'badge-custom-danger':'badge-success'}`} title={`Module Fault`} alarm={alarm_count?.length>0?alarm_count[0]?.module_fault:0} />
                 
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="row">
            <div className="col-xl-12">
              <table className="table table-borderless rms-all-nav m-0">
                <tbody>
               
                  <RectifierAlarmTd link={`/rectifier_live_alarm?type=6`} className={`text-center ${alarm_count?.length>0 && alarm_count[0]?.fuse_fault?'badge-custom-danger':'badge-success'} fw-bold`}  title={`Fuse Fault`} alarm={alarm_count?.length>0?alarm_count[0]?.fuse_fault:0} />
                  <RectifierAlarmTd link={`/rectifier_live_alarm?type=3`} className={`text-center ${alarm_count?.length>0 && alarm_count[0]?.llvd?'badge-custom-danger':'badge-success'} fw-bold`}   title={`LLVD`} alarm={alarm_count?.length>0?alarm_count[0]?.llvd:0} />
                  <RectifierAlarmTd link={`/rectifier_live_alarm?type=4`} className={`text-center ${alarm_count?.length>0 && alarm_count[0]?.blvd?'badge-custom-danger':'badge-success'} fw-bold`}  title={`BLVD`} alarm={alarm_count?.length>0?alarm_count[0]?.blvd:0} />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )

}